import http from '../../plugins/http.js';

const state = {
  draftId: '',
  list: []
}

const getters = {
  list: state => state.list,
}

const mutations = {
  setList (state, list) {
    state.list = list;
  },
  setDraftId (state, id) {
    state.draftId = id;
  }
}

const actions = {
  async fetchList ({commit, state}, {draftId} = {}) {
    draftId = draftId || state.draftId;
    let resp = await http.get(`/api/user/draft/version?draftId=${draftId}`);
    let {data: resData} = resp.data;
    let list = resData || [];
    commit('setList', list.slice(0, 20));
    return state.list;
  },
  async createVersion ({commit, state}, {draftId, comment} = {}) {
    draftId = draftId || state.draftId;
    let resp = await http.post('/api/user/draft/version', {
      draftId,
      comment
    });
    let {data: resData} = resp.data;
    let item = resData || {};
    let list = [item, ...state.list].slice(0, 20);
    commit('setList', list);
    return state.list;
  },
  async updateComment ({commit}, {versionId, comment}={}) {
    let resp = await http.post('/api/user/draft/updateversioncomment', {
      versionId,
      comment
    });
    return resp;
  },
  async removeVersion ({commit, state}, {versionId}={}) {
    let resp = await http.post('/api/user/draft/deleteversion', {
      versionId
    });
    let {code: code} = resp.data;
    if (code === 200) {
      return versionId;
    }
  },
  async revertVersion ({commit, state}, {draftId, versionId}={}) {
    draftId = draftId || state.draftId;
    const resp = await http.post('/api/user/draft/recovery', {
      uid: draftId, versionId
    });
    let {code: code} = resp.data;
    if (code === 200) {
      return true;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/draftVersion.js